import { render, staticRenderFns } from "./StylistCustomers.vue?vue&type=template&id=3c9fce59&scoped=true&"
import script from "./StylistCustomers.vue?vue&type=script&lang=js&"
export * from "./StylistCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9fce59",
  null
  
)

export default component.exports